import { Alert } from 'react-native';

type TranslateFn = (key: string) => string;

/** Native sign-in / sign-up prompt — same copy and actions as Consultation guest booking. */
export function promptAccountRequiredAlert(
  t: TranslateFn,
  handlers: { openLogin: () => void; openRegister: () => void },
): void {
  Alert.alert(t('consultation.accountRequiredTitle'), t('consultation.accountRequiredMessage'), [
    { text: t('common.cancel'), style: 'cancel' },
    { text: t('auth.signIn'), onPress: handlers.openLogin },
    { text: t('auth.createAccount'), onPress: handlers.openRegister },
  ]);
}
